import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type VideoSlideTemplatesQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.VideoSlideTemplatesFilters>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
}>;


export type VideoSlideTemplatesQuery = { videoSlideTemplates: { edges?: Array<{ node: { id: string, name: string, heygen_template_id: string, preview_url?: string | null, variableSchema?: string | null } }> | null } };


export const VideoSlideTemplatesDocument = /*#__PURE__*/ gql`
    query videoSlideTemplates($filters: VideoSlideTemplatesFilters, $first: Float, $after: String, $sort: [SortType!]) {
  videoSlideTemplates(
    filters: $filters
    first: $first
    after: $after
    sort: $sort
  ) {
    edges {
      node {
        id
        name
        heygen_template_id
        preview_url
        variableSchema
      }
    }
  }
}
    `;

export function useVideoSlideTemplatesQuery(options?: Omit<Urql.UseQueryArgs<VideoSlideTemplatesQueryVariables>, 'query'>) {
  return Urql.useQuery<VideoSlideTemplatesQuery, VideoSlideTemplatesQueryVariables>({ query: VideoSlideTemplatesDocument, ...options });
};